import axios from "axios";
import {
  CLEAR_INVENTORY_DETAILS,
  CLOSE_BOX_FAILURE,
  CLOSE_BOX_REQUEST,
  CLOSE_BOX_SUCCESS,
  CREATE_BOX_FAILURE,
  CREATE_BOX_REQUEST,
  CREATE_BOX_SUCCESS,
  CREATE_MRP_LABEL_FAILURE,
  CREATE_MRP_LABEL_REQUEST,
  CREATE_MRP_LABEL_SUCCESS,
  DEACTIVATE_HOLD_FAILURE,
  DEACTIVATE_HOLD_REQUEST,
  DEACTIVATE_HOLD_SUCCESS,
  DOWNLOAD_BOX_LABEL_FAILURE,
  DOWNLOAD_BOX_LABEL_REQUEST,
  DOWNLOAD_BOX_LABEL_SUCCESS,
  GET_BATCH_DETAILS_FAILURE,
  GET_BATCH_DETAILS_REQUEST,
  GET_BATCH_DETAILS_SUCCESS,
  GET_BATCHES_FAILURE,
  GET_BATCHES_REQUEST,
  GET_BATCHES_SUCCESS,
  GET_BOX_SETTING_FAILURE,
  GET_BOX_SETTING_REQUEST,
  GET_BOX_SETTING_SUCCESS,
  GET_BOX_TYPE_FAILURE,
  GET_BOX_TYPE_REQUEST,
  GET_BOX_TYPE_SUCCESS,
  GET_FROM_LOCATION_DROPDOWN_LIST_FAILURE,
  GET_FROM_LOCATION_DROPDOWN_LIST_REQUEST,
  GET_FROM_LOCATION_DROPDOWN_LIST_SUCCESS,
  GET_INVENTORY_DETAILS_FAILURE,
  GET_INVENTORY_DETAILS_REQUEST,
  GET_INVENTORY_DETAILS_SUCCESS,
  GET_INVOICE_LIST_FAILURE,
  GET_INVOICE_LIST_REQUEST,
  GET_INVOICE_LIST_SUCCESS,
  GET_MISSING_INVENTORY_LIST_FAILURE,
  GET_MISSING_INVENTORY_LIST_REQUEST,
  GET_MISSING_INVENTORY_LIST_SUCCESS,
  GET_PARTY_LIST_FAILURE,
  GET_PARTY_LIST_REQUEST,
  GET_PARTY_LIST_SUCCESS,
  GET_PORTAL_NET_INVENTORY_FAILURE,
  GET_PORTAL_NET_INVENTORY_REQUEST,
  GET_PORTAL_NET_INVENTORY_SUCCESS,
  GET_PRODUCTS_LIST_FAILURE,
  GET_PRODUCTS_LIST_REQUEST,
  GET_PRODUCTS_LIST_SUCCESS,
  GET_SALES_ANALYSIS_LIST_FAILURE,
  GET_SALES_ANALYSIS_LIST_REQUEST,
  GET_SALES_ANALYSIS_LIST_SUCCESS,
  GET_SKU_PRODUCTS_FAILURE,
  GET_SKU_PRODUCTS_REQUEST,
  GET_SKU_PRODUCTS_SUCCESS,
  GET_SUB_ORDER_SUMMARY_FAILURE,
  GET_SUB_ORDER_SUMMARY_REQUEST,
  GET_SUB_ORDER_SUMMARY_SUCCESS,
  GET_SUBLOCATION_LIST_FAILURE,
  GET_SUBLOCATION_LIST_REQUEST,
  GET_SUBLOCATION_LIST_SUCCESS,
  GET_TEMP_HOLD_SUMMARY_FAILURE,
  GET_TEMP_HOLD_SUMMARY_REQUEST,
  GET_TEMP_HOLD_SUMMARY_SUCCESS,
  GET_TO_LOCATION_DROPDOWN_LIST_FAILURE,
  GET_TO_LOCATION_DROPDOWN_LIST_REQUEST,
  GET_TO_LOCATION_DROPDOWN_LIST_SUCCESS,
  GET_USER_PROFILE_FAILURE,
  GET_USER_PROFILE_REQUEST,
  GET_USER_PROFILE_SUCCESS,
  HOURLY_PRODUCTION__REPORT_FAILURE,
  HOURLY_PRODUCTION__REPORT_REQUEST,
  HOURLY_PRODUCTION__REPORT_SUCCESS,
  MARK_HOLD_FAILURE,
  MARK_HOLD_REQUEST,
  MARK_HOLD_SUCCESS,
  PORTAL_NET_INVENTORY_POPUP_FAILURE,
  PORTAL_NET_INVENTORY_POPUP_REQUEST,
  PORTAL_NET_INVENTORY_POPUP_SUCCESS,
  PRODUCT_SUB_GROUP_MASTER_DATA_FAILURE,
  PRODUCT_SUB_GROUP_MASTER_DATA_REQUEST,
  PRODUCT_SUB_GROUP_MASTER_DATA_SUCCESS,
  PRODUCT_WISE_CONSOLIDATED_REPORT_FAILURE,
  PRODUCT_WISE_CONSOLIDATED_REPORT_REQUEST,
  PRODUCT_WISE_CONSOLIDATED_REPORT_SUCCESS,
  SALES_ANALYSIS_DETAILS_FAILURE,
  SALES_ANALYSIS_DETAILS_REQUEST,
  SALES_ANALYSIS_DETAILS_SUCCESS,
  SAVE_BOX_SETTING_FAILURE,
  SAVE_BOX_SETTING_REQUEST,
  SAVE_BOX_SETTING_SUCCESS,
  SAVE_BOX_TYPE_FAILURE,
  SAVE_BOX_TYPE_REQUEST,
  SAVE_BOX_TYPE_SUCCESS,
  SAVE_TEMP_HOLD_INVENTORY_FAILURE,
  SAVE_TEMP_HOLD_INVENTORY_REQUEST,
  SAVE_TEMP_HOLD_INVENTORY_SUCCESS,
  SCAN_SERIAL_BOX_INVENTORY_FAILURE,
  SCAN_SERIAL_BOX_INVENTORY_REQUEST,
  SCAN_SERIAL_BOX_INVENTORY_SUCCESS,
  SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE,
  SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST,
  SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS,
  SYNC_CRON_FUNCTION_FAILURE,
  SYNC_CRON_FUNCTION_REQUEST,
  SYNC_CRON_FUNCTION_SUCCESS,
  VIEW_PREVIOUS_BOX_FAILURE,
  VIEW_PREVIOUS_BOX_REQUEST,
  VIEW_PREVIOUS_BOX_SUCCESS,
} from "../Constants/ProductionConstants";
import { BASEURI } from "../Middleware/axiosInstance";
import { URI } from "./AuditActions";

// ************************************* Manufacturing Actions *************************************

// let conditions = {
//   only_parent: true,
//   is_company_location: true,
//   is_active: true,
//   is_manufacture_location: true,
// };

// From Location Dropdown List Actions
export const FromLocationDropdownListActions =
  (service_name, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_FROM_LOCATION_DROPDOWN_LIST_REQUEST,
      });

      let body = {
        // only_parent: true,
        // is_company_location: true,
        is_active: true,
        is_manufacture_location: true,
      };

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        conditions: body,
        token,
      });
      dispatch({
        type: GET_FROM_LOCATION_DROPDOWN_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_FROM_LOCATION_DROPDOWN_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// To Location Dropdown List Actions
export const ToLocationDropdownListActions =
  (service_name, user_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_TO_LOCATION_DROPDOWN_LIST_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        user_id,
        token,
      });
      dispatch({
        type: GET_TO_LOCATION_DROPDOWN_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_TO_LOCATION_DROPDOWN_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Invoice List Actions
export const GetInvoiceListDropdownListActions =
  (service_name, user_id, conditions, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_INVOICE_LIST_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        user_id,
        conditions,
        token,
      });
      dispatch({
        type: GET_INVOICE_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_INVOICE_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Inventory Details Actions
export const GetInventoryDetailsActions =
  (service_name, inventory_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_INVENTORY_DETAILS_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        token,
      });
      dispatch({
        type: GET_INVENTORY_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_INVENTORY_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Table List/Products List Actions
export const GetProductListActions =
  (service_name, inventory_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_PRODUCTS_LIST_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        token,
      });
      dispatch({
        type: GET_PRODUCTS_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PRODUCTS_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Party List Actions
export const GetPartyListActions =
  (service_name, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_PARTY_LIST_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
      });
      dispatch({
        type: GET_PARTY_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PARTY_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Sub Location List Actions
export const GetSubLocationListActions =
  (service_name, location_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_SUBLOCATION_LIST_REQUEST,
      });

      let conditions = {
        location_id: location_id,
      };

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        conditions,
        token,
      });
      dispatch({
        type: GET_SUBLOCATION_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_SUBLOCATION_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// View Previous Box Actions
export const ViewPreviousBoxActions =
  (service_name, inventory_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: VIEW_PREVIOUS_BOX_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        token,
      });
      dispatch({
        type: VIEW_PREVIOUS_BOX_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: VIEW_PREVIOUS_BOX_FAILURE,
        payload: error.message,
      });
    }
  };

// Scan Serial Box
export const ScanSerialBoxActions =
  (
    service_name,
    inventory_id,
    party_id,
    box_id,
    serial_code,
    sub_location_id,
    from_Location_id,
    token
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: SCAN_SERIAL_BOX_INVENTORY_REQUEST,
      });

      let body = {
        service_name,
        inventory_id,
        data: {
          party_id: party_id,
          box_id: box_id,
          serial_code: serial_code,
          sub_location_id: sub_location_id,
          from_location_id: from_Location_id,
        },
        token,
      };

      const { data } = await axios.post(`${BASEURI}`, body);
      dispatch({
        type: SCAN_SERIAL_BOX_INVENTORY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SCAN_SERIAL_BOX_INVENTORY_FAILURE,
        payload: error.message,
      });
    }
  };

// Create MRP labeL Actions
export const CreateMRPLabelActions =
  (service_name, inventory_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: CREATE_MRP_LABEL_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        token,
      });
      dispatch({
        type: CREATE_MRP_LABEL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_MRP_LABEL_FAILURE,
        payload: error.message,
      });
    }
  };

// Close Box Actions
export const CloseBoxActions =
  (service_name, inventory_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: CLOSE_BOX_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        token,
      });
      dispatch({
        type: CLOSE_BOX_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CLOSE_BOX_FAILURE,
        payload: error.message,
      });
    }
  };

// Create Box Actions
export const CreateBoxActions =
  (
    service_name,
    inventory_id,
    sub_location_id,
    has_single_sku,
    box_type_id,
    token
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BOX_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        sub_location_id,
        has_single_sku,
        box_type_id,
        token,
      });
      dispatch({
        type: CREATE_BOX_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_BOX_FAILURE,
        payload: error.message,
      });
    }
  };

// Download Box Label Actions
export const DownloadBoxLabelActions =
  (service_name, inventory_id, box_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: DOWNLOAD_BOX_LABEL_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        box_id,
        token,
      });
      dispatch({
        type: DOWNLOAD_BOX_LABEL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: DOWNLOAD_BOX_LABEL_FAILURE,
        payload: error.message,
      });
    }
  };

// Get SKU Products Actions
export const GetSKUProductsActions =
  (service_name, inventory_id, box_id, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_SKU_PRODUCTS_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        inventory_id,
        box_id,
        token,
      });
      dispatch({
        type: GET_SKU_PRODUCTS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_SKU_PRODUCTS_FAILURE,
        payload: error.message,
      });
    }
  };

// Get User Profile Actions
export const getUserProfileActions =
  (service_name, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_USER_PROFILE_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
      });
      dispatch({
        type: GET_USER_PROFILE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_USER_PROFILE_FAILURE,
        payload: error.message,
      });
    }
  };

// Clear Inventory Details Actions
export const clearInventoryDetails = () => ({
  type: CLEAR_INVENTORY_DETAILS,
});

// Save Box Type Actions
export const saveBoxTypeActions =
  (service_name, token, box_types) => async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BOX_TYPE_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        box_types,
      });
      dispatch({
        type: SAVE_BOX_TYPE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SAVE_BOX_TYPE_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Box Type Actions
export const getBoxTypeActions =
  (service_name, token, box_types) => async (dispatch) => {
    try {
      dispatch({
        type: GET_BOX_TYPE_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        box_types,
      });
      dispatch({
        type: GET_BOX_TYPE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_BOX_TYPE_FAILURE,
        payload: error.message,
      });
    }
  };

// Save Box Setting Actions
export const saveBoxSettingActions =
  (service_name, token, setting) => async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BOX_SETTING_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        setting,
      });
      dispatch({
        type: SAVE_BOX_SETTING_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SAVE_BOX_SETTING_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Box Setting Actions
export const getBoxSettingActions =
  (service_name, token) => async (dispatch) => {
    try {
      dispatch({
        type: GET_BOX_SETTING_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
      });
      dispatch({
        type: GET_BOX_SETTING_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_BOX_SETTING_FAILURE,
        payload: error.message,
      });
    }
  };

// Product Sub Group Cost Master Data Actions
export const ProductSubGroupCostMasterDataActions = () => async (dispatch) => {
  try {
    dispatch({
      type: PRODUCT_SUB_GROUP_MASTER_DATA_REQUEST,
    });

    const { data } = await axios.get(
      `${URI}/QualityManager/product_group_settings`
    );
    dispatch({
      type: PRODUCT_SUB_GROUP_MASTER_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_SUB_GROUP_MASTER_DATA_FAILURE,
      payload: error.message,
    });
  }
};

// Get Batches Actions
// export const getBatchesActions =
//   (
//     service_name,
//     product_group_id,
//     batch_id,
//     batch_qty,
//     total_finished_qty,
//     pending_qty,
//     page,
//     token
//   ) =>
//   async (dispatch) => {
//     const payload = {};

//     if (service_name) payload.service_name = service_name;
//     if (product_group_id) payload.product_group_id = product_group_id;
//     if (batch_id) payload.batch_id = batch_id;
//     if (batch_qty) payload.batch_qty = batch_qty;
//     if (total_finished_qty) payload.total_finished_qty = total_finished_qty;
//     if (pending_qty) payload.pending_qty = pending_qty;
//     if (page) payload.page = page;
//     if (token) payload.token = token;
//     try {
//       dispatch({
//         type: GET_BATCHES_REQUEST,
//       });

//       const { data } = await axios.post(`${BASEURI}`, payload);
//       dispatch({
//         type: GET_BATCHES_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: GET_BATCHES_FAILURE,
//         payload: error.message,
//       });
//     }
//   };

// Actions/ProductionActions.js
// export const getBatchesActions =
//   (service_name, filters, page, token) => async (dispatch) => {
//     const payload = {
//       service_name,
//       page,
//       token,
//     };

//     if (filters && Object.keys(filters).length > 0) {
//       payload.filter = filters;
//     }

//     try {
//       dispatch({ type: GET_BATCHES_REQUEST });
//       const { data } = await axios.post(`${BASEURI}`, payload);
//       dispatch({ type: GET_BATCHES_SUCCESS, payload: data });
//     } catch (error) {
//       dispatch({ type: GET_BATCHES_FAILURE, payload: error.message });
//     }
//   };

export const getBatchesActions =
  (service_name, filters, page, limit, token) => async (dispatch) => {
    const payload = {
      service_name,
      page,
      limit,
      token,
    };

    // 🧹 Clean filters: remove empty, null, undefined
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters || {}).filter(
        ([, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    if (Object.keys(cleanedFilters).length > 0) {
      payload.filter = cleanedFilters;
    }

    try {
      dispatch({ type: GET_BATCHES_REQUEST });
      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({ type: GET_BATCHES_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_BATCHES_FAILURE, payload: error.message });
    }
  };

// Get Batch Details Actions
export const getBatchDetailsActions =
  (service_name, token, batch_id) => async (dispatch) => {
    try {
      dispatch({
        type: GET_BATCH_DETAILS_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        batch_id,
      });
      dispatch({
        type: GET_BATCH_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_BATCH_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };

// Mark Hold Actions
export const MarkHoldActions =
  (service_name, token, batch_id, process_node_id) => async (dispatch) => {
    try {
      dispatch({
        type: MARK_HOLD_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, {
        service_name,
        token,
        batch_id,
        process_node_id,
      });
      dispatch({
        type: MARK_HOLD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: MARK_HOLD_FAILURE,
        payload: error.message,
      });
    }
  };

// Product Wise Consolidated Report Actions
export const ProductLevelConsolidatedReportActions =
  (
    service_name,
    token,
    group,
    page,
    limit,
    product_group_id,
    product_id,
    date,
    show_critical_node_only
  ) =>
  async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (page) payload.page = page;
    if (token) payload.token = token;
    if (group) payload.group = group;
    if (limit) payload.limit = limit;

    payload.filters = {};
    if (product_group_id) payload.filters.product_group_id = product_group_id;
    if (product_id) payload.filters.product_id = product_id;
    if (date) payload.filters.date = date;
    if (show_critical_node_only)
      payload.filters.show_critical_node_only = show_critical_node_only;
    try {
      dispatch({
        type: PRODUCT_WISE_CONSOLIDATED_REPORT_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({
        type: PRODUCT_WISE_CONSOLIDATED_REPORT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PRODUCT_WISE_CONSOLIDATED_REPORT_FAILURE,
        payload: error.message,
      });
    }
  };

// Hourly Production Report Actions
export const HourlyProductionReportActions =
  (
    service_name,
    token,
    group,
    page,
    limit,
    product_group_id,
    product_id,
    date,
    show_critical_node_only
  ) =>
  async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (page) payload.page = page;
    if (token) payload.token = token;
    if (group) payload.group = group;
    if (limit) payload.limit = limit;

    payload.filters = {};
    if (product_group_id) payload.filters.product_group_id = product_group_id;
    if (product_id) payload.filters.product_id = product_id;
    if (date) payload.filters.date = date;
    if (show_critical_node_only)
      payload.filters.show_critical_node_only = show_critical_node_only;
    try {
      dispatch({
        type: HOURLY_PRODUCTION__REPORT_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({
        type: HOURLY_PRODUCTION__REPORT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: HOURLY_PRODUCTION__REPORT_FAILURE,
        payload: error.message,
      });
    }
  };

// // Get Suborder Summary Actions
// export const getSubOrderSummaryActions =
//   (
//     service_name,
//     page,
//     token,
//     filters
//   ) =>
//   async (dispatch) => {
//     const payload = {};

//     if (service_name) payload.service_name = service_name;
//     if (token) payload.token = token;
//     if (page) payload.page = page;
//     if (sub_order_from_date) payload.sub_order_from_date = sub_order_from_date;
//     if (sub_order_to_date) payload.sub_order_to_date = sub_order_to_date;
//     if (sub_order_created_by)
//       payload.sub_order_created_by = sub_order_created_by;
//     try {
//       dispatch({
//         type: GET_SUB_ORDER_SUMMARY_REQUEST,
//       });

//       const { data } = await axios.post(`${BASEURI}`, payload);
//       dispatch({
//         type: GET_SUB_ORDER_SUMMARY_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: GET_SUB_ORDER_SUMMARY_FAILURE,
//         payload: error.message,
//       });
//     }
//   };

// Get Suborder Summary Actions
export const getSubOrderSummaryActions =
  (service_name, page, token, filters = {}) =>
  async (dispatch) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v !== "" && v !== null)
    );

    const payload = {
      service_name,
      token,
      page,
      filters: cleanFilters,
    };

    try {
      dispatch({ type: GET_SUB_ORDER_SUMMARY_REQUEST });

      const { data } = await axios.post(`${BASEURI}`, payload);

      dispatch({
        type: GET_SUB_ORDER_SUMMARY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_SUB_ORDER_SUMMARY_FAILURE,
        payload: error.message,
      });
    }
  };

// Save Temp Hold Inventory Actions
export const saveTempHoldInventoryActions =
  (
    service_name,
    token,
    product_group_id,
    category_style_color,
    product_id,
    batch_id,
    location_id,
    sub_location_id,
    b_grade_location,
    all_high_availability_locations,
    minimumThresholdValue,
    thresholdApplicableOn,
    reason_id,
    hold_from_datetime,
    hold_to_datetime,
    holdType,
    remark
  ) =>
  async (dispatch) => {
    const obj = {
      service_name,
      token,
      data: {
        remark,
        product_group_id: product_group_id?.value ?? null,
        category_style_color: category_style_color?.value ?? null,
        product_id: product_id?.value ?? null,
        batch_id: batch_id?.value ?? null,
        location_id: location_id?.value ?? null,
        sub_location_id: sub_location_id?.value ?? null,
        all_b_grade_locations: b_grade_location ?? [],
        all_high_availability_locations: all_high_availability_locations ?? [],
        reason_id: reason_id?.value ?? null,
        hold_from_datetime,
        hold_to_datetime,
        hold_type: holdType?.value ?? null,
        // minimumThresholdValue,
        // thresholdApplicableOn,
      },
    };
    try {
      dispatch({
        type: SAVE_TEMP_HOLD_INVENTORY_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, obj);
      dispatch({
        type: SAVE_TEMP_HOLD_INVENTORY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SAVE_TEMP_HOLD_INVENTORY_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Temp Hold Summary Actions
// export const getTempHoldSummaryActions =
//   (service_name, page, token) => async (dispatch) => {
//     const payload = {};

//     if (service_name) payload.service_name = service_name;
//     if (token) payload.token = token;
//     if (page) payload.page = page;
//     try {
//       dispatch({
//         type: GET_TEMP_HOLD_SUMMARY_REQUEST,
//       });

//       const { data } = await axios.post(`${BASEURI}`, payload);
//       dispatch({
//         type: GET_TEMP_HOLD_SUMMARY_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: GET_TEMP_HOLD_SUMMARY_FAILURE,
//         payload: error.message,
//       });
//     }
//   };

export const getTempHoldSummaryActions =
  (service_name, page, token, filters = {}) =>
  async (dispatch) => {
    const payload = {
      ...(service_name && { service_name }),
      ...(token && { token }),
      ...(page && { page }),
      filters: Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== "" && v !== null)
      ),
    };

    try {
      dispatch({
        type: GET_TEMP_HOLD_SUMMARY_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({
        type: GET_TEMP_HOLD_SUMMARY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_TEMP_HOLD_SUMMARY_FAILURE,
        payload: error.message,
      });
    }
  };

// Deactivate Temp Hold Actions
export const DeactivateTempHoldActions =
  (service_name, token, hold_id) => async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (token) payload.token = token;
    if (hold_id) payload.data = { hold_id };
    try {
      dispatch({
        type: DEACTIVATE_HOLD_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({
        type: DEACTIVATE_HOLD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: DEACTIVATE_HOLD_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Portal Net Inventory Actions
export const getPortalNetInventoryActions =
  (service_name, page, limit, filters, group, token) => async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (token) payload.token = token;
    if (page) payload.page = page;
    if (limit) payload.limit = limit;
    if (group) payload.group = group;
    // if (product_id) payload.product_id = product_id;
    // if (product_group_id) payload.product_group_id = product_group_id;
    // if (date) payload.date = date;
    
    if (filters) {
      payload.filters = {};

      if (filters.product_id) payload.filters.product_id = filters.product_id;

      if (filters.from) payload.filters.from = filters.from;
      if (filters.to) payload.filters.to = filters.to;
      if (filters.sync_id) payload.filters.sync_id = filters.sync_id;
      if (filters.category_style_color) payload.filters.category_style_color = filters.category_style_color;

      if (filters.product_group_id)
        payload.filters.product_group_id = filters.product_group_id;
    }

    try {
      dispatch({
        type: GET_PORTAL_NET_INVENTORY_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({
        type: GET_PORTAL_NET_INVENTORY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PORTAL_NET_INVENTORY_FAILURE,
        payload: error.message,
      });
    }
  };

// Get SubOrder Level View Consolidated Actions
// export const getSubOrderLevelViewActions =
//   (service_name, page, token, group) => async (dispatch) => {
//     const payload = {};

//     if (service_name) payload.service_name = service_name;
//     if (token) payload.token = token;
//     if (page) payload.page = page;
//     if (group) payload.group = group;
//     try {
//       dispatch({
//         type: SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST,
//       });

//       const { data } = await axios.post(`${BASEURI}`, payload);
//       dispatch({
//         type: SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE,
//         payload: error.message,
//       });
//     }
//   };

export const getSubOrderLevelViewActions =
  (service_name, page, token, group, filters = {}) =>
  async (dispatch) => {
    let payload = {};

    if (service_name) payload.service_name = service_name;
    if (token) payload.token = token;
    if (page) payload.page = page;
    if (group) payload.group = group;

    // ✅ Wrap filters inside "filters" key
    const cleanedFilters = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        cleanedFilters[key] = value;
      }
    });

    if (Object.keys(cleanedFilters).length > 0) {
      payload.filters = cleanedFilters;
    }

    try {
      dispatch({ type: SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST });

      const { data } = await axios.post(`${BASEURI}`, payload);

      dispatch({
        type: SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Sales Analysis List Actions
export const getSalesAnalysisListActions =
  (service_name, token, filters) => async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (token) payload.token = token;
    if (filters) payload.filters = filters;
    try {
      dispatch({
        type: GET_SALES_ANALYSIS_LIST_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);
      dispatch({
        type: GET_SALES_ANALYSIS_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_SALES_ANALYSIS_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// Get Sales Analysis Details Actions
export const getSalesAnalysisDetailsActions =
  (service_name, token, from, filters) => async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (token) payload.token = token;
    if (from) payload.from = from;

    // ✅ Build filters object only if values exist
    // if (filters) {
    //   payload.filters = {};

    //   if (filters.category_style_color)
    //     payload.filters.category_style_color = filters.category_style_color;

    //   if (filters.unit_of_reporting)
    //     payload.filters.unit_of_reporting = filters.unit_of_reporting;

    //   // if (filters.style) payload.filters.style = filters.style;

    //   // 👉 add more filter checks here if needed
    // }

    if (filters) payload.filters = filters;

    try {
      dispatch({
        type: SALES_ANALYSIS_DETAILS_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);

      dispatch({
        type: SALES_ANALYSIS_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SALES_ANALYSIS_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };

// get Missing Inventory List Actions
export const getMissingInventoryListActions =
  (service_name, token) => async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (token) payload.token = token;

    try {
      dispatch({
        type: GET_MISSING_INVENTORY_LIST_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);

      dispatch({
        type: GET_MISSING_INVENTORY_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_MISSING_INVENTORY_LIST_FAILURE,
        payload: error.message,
      });
    }
  };

// Portal Net Inventory Popup Actions
export const PortalNetInventoryPopupActions =
  (service_name, type, sync_number, key_id, group, token) =>
  async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (type) payload.type = type;
    if (sync_number) payload.sync_number = sync_number;
    if (key_id) payload.key_id = key_id;
    if (group) payload.group = group;
    if (token) payload.token = token;

    try {
      dispatch({
        type: PORTAL_NET_INVENTORY_POPUP_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);

      dispatch({
        type: PORTAL_NET_INVENTORY_POPUP_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PORTAL_NET_INVENTORY_POPUP_FAILURE,
        payload: error.message,
      });
    }
  };

// Run Func Cron Function Reducers Actions
export const RunCronFunctionActions =
  (service_name, cron, token) => async (dispatch) => {
    const payload = {};

    if (service_name) payload.service_name = service_name;
    if (cron) payload.cron = cron;
    if (token) payload.token = token;

    try {
      dispatch({
        type: SYNC_CRON_FUNCTION_REQUEST,
      });

      const { data } = await axios.post(`${BASEURI}`, payload);

      dispatch({
        type: SYNC_CRON_FUNCTION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: SYNC_CRON_FUNCTION_FAILURE,
        payload: error.message,
      });
    }
  };
